import {
  Box,
  Checkbox,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMReturnRate } from "../../../../model/TblDMReturnRate";

const DetailDataView = ({ id }: DetailDataViewProps) => {
  const entity = {
    id: "0",
    fromDate: 0,
    toDate: 0,
    returnRate: 0,
    note: null,
    active: false,
    updateDate: null,
    createDate: null,
    levelName: null,
    createBy: null,
    lastUpdateBy: null,
    lastUpdateDate: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<TblDMReturnRate>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
  });

  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<MessageResponse<TblDMReturnRate>>(
      `/api/v1/TblDMReturnRate/detail?id=${id}`
    );
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);

  return (
    <>
      <Box component="form" mx="auto" style={{ position: "relative" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Group grow wrap="nowrap" mt={10} gap={"lg"}>
          <TextInput
            readOnly
            variant="filled"
            label={"Từ số ngày"}
            {...form.getInputProps("fromDate")}
          />
          <TextInput
            readOnly
            variant="filled"
            label={"Đến số ngày"}
            {...form.getInputProps("toDate")}
          />
        </Group>

        <Group grow wrap="nowrap" mt={10} gap={"lg"}>
          <TextInput
            readOnly
            variant="filled"
            label={"Tên mức"}
            {...form.getInputProps("levelName")}
          />
          <TextInput
            readOnly
            variant="filled"
            label={"Tỷ lệ nhập lại"}
            {...form.getInputProps("returnRate")}
          />
        </Group>

        <Group grow wrap="nowrap" mt={10} mb={"md"} gap={"lg"} align="center">
          <Textarea
            readOnly
            variant="filled"
            label={"Ghi chú"}
            w={"100%"}
            {...form.getInputProps("note")}
          />
        </Group>
        <Checkbox
          readOnly
          label={"Sử dụng"}
          checked={form.values.active || false}
          {...form.getInputProps("active")}
          onChange={() => {}}
        />
      </Box>
    </>
  );
};

export default DetailDataView;

type DetailDataViewProps = {
  id: string | number;
};
